module.exports = __webpack_public_path__ + "img/caniuse-promise.434caf8a.png";